import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuiBreadcrumbsModule } from '@taiga-ui/kit';
import { TuiButtonModule, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'us-open-browser',
    standalone: true,
    imports: [RouterModule, TuiBreadcrumbsModule, NgIf, TuiButtonModule, TranslocoModule, NgOptimizedImage],
    template: `
        <h2 class="text-center my-2">{{ 'open_to_browser' | transloco }}</h2>
        <ng-container *ngIf="!isAndroid">
            <p class="text-center mb-2 px-5">{{ 'image_of_opening_instructions' | transloco }}</p>
            <img
                [ngSrc]="'/assets/images/open_to_browser2.png'"
                [width]="382"
                [height]="255"
                alt="share-order"
                class="h-auto w-full max-w-xl my-4 object-contain"
            />
        </ng-container>
        <ng-container *ngIf="isAndroid">
            <div class="flex justify-center my-3">
                <a [href]="url" tuiButton size="m">
                    {{ 'openv2' | transloco }}
                </a>
            </div>
        </ng-container>
    `,
    styles: [
        `
            :host {
                display: block;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpenBrowserComponent {
    public readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<any, {
        url: string;
        isAndroid: boolean;
    }>;

    url = `intent:${this.context.data.url}#Intent;end`;
    isAndroid = this.context.data.isAndroid;

}
